<template>
  <div class="common-box margin-l6">
    <el-row class="row-one">
      <span class="row-one-title">我的相关问题</span>
      <a v-if="questionShow" class="row-one-fr" href="https://www.myfund.com/NewdiagnosisOfEntrance.html?type=2" target="_block">去提问</a>
    </el-row>
    <div v-if="!questionShow" class="noQuestion">
      <img src="../../assets/images/diagnosis1.png" alt="">
      <p class="noQuestion-con">您暂无任何提问 ！</p>
      <a href="https://www.myfund.com/NewdiagnosisOfEntrance.html?type=2" class="noQuestion-ask" target="_block">去提问</a>
    </div>
    <div v-else style="margin-bottom: 111px;">
      <ul class="question">
        <li v-for="(item,i) in questionLists" :key="i">
          <div class="clearfix margin-b15">
            <a class="fl question-tit" :href="'https://www.myfund.com/mutualfund/' + item.fundCode +'.html'" target="_block">{{item.fundName + '（' + item.fundCode + '）'}}</a>
            <span class="fr" style="line-height: 26px;">{{'发表于'+item.AddDate}}</span>
          </div>
          <div class="question-con clearfix">
            <i>问</i>
            <span style="color:#333;">{{item.Question}}</span>
          </div>
          <div class="question-con clearfix">
            <i>答</i>
            <span>{{item.Answer? item.Answer:'暂无回答'}}</span>
          </div>
        </li>
      </ul>
      <!-- 分页 -->
      <el-pagination class="pagination-single" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      questionShow: true,
      questionLists: [],
      pageNum: 0,
      pageSize: 3,
      total: 0
    }
  },
  mounted () {
    this.getQuestion()
  },
  methods: {
    getQuestion (page, size) {
      this.$http.get(this.$apiPath.DiagnosticQA, {
        userPhone: this.$commonJs.getCookie('u_phone1'),
        page: (page || 1) - 1,
        pageCount: size || 3,
      }).then(res => {
        // console.log(res);
        if (res.data.Result) {
          if (res.data.List.length > 0) {
            this.questionShow = true
            this.questionLists = res.data.List
            this.total = res.data.recordCount
          } else {
            this.questionShow = false
          }
        }
      }).catch(err => { })
    },
    handleCurrentChange (newPage) {
      this.pageNum = newPage
      this.getQuestion(newPage, this.pageSize)
    },
    handleSizeChange (newSize) {
      this.pageNum = 1
      this.pageSize = newSize
      this.getQuestion(this.pageNum, newSize)
    }
  }
}
</script>


<style lang="less" scoped>
.noQuestion {
  margin: 116.5px auto;
  text-align: center;
  &-con {
    margin: 15px;
    color: @color6;
  }
  &-ask {
    display: inline-block;
    width: 110px;
    height: 30px;
    line-height: 30px;
    background: @color;
    color: @wColor;
    border-radius: 5px;
  }
}
.question {
  padding: 15px 44px;
  color: @color6;
  li {
    position: relative;
    box-sizing: border-box;
    padding: 25px 0;
    border-bottom: 1px dashed @colorC5;
    text-align: justify;
  }
  li::before {
    position: absolute;
    left: -18px;
    top: 35px;
    content: "";
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #7ca8ce;
  }
  &-tit {
    font-size: 20px;
    color: @color;
  }
  &-tit:hover {
    color: @rColor;
  }
  &-con {
    font-size: 16px;
    margin-top: 5px;
    i {
      float: left;
      display: block;
      width: 22px;
      height: 22px;
      background: @color;
      border-radius: 50%;
      color: @wColor;
      text-align: center;
      line-height: 22px;
      margin-right: 15px;
      margin-top: 4px;
      font-size: 12px;
    }
    span {
      width: calc(100% - 37px);
      float: left;
      display: block;
      line-height: 30px;
    }
  }
}
</style>